import { onDomReady } from '../components/dynamic/observer';
import { DADATA_PUBLIC_TOKEN } from './config/dadata';

const DADATA_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';

onDomReady(() => {
  const selector = document.querySelector('[data-city-selector]');

  if (!selector) {
    return;
  }

  const search = selector.querySelector('[data-city-search]');
  const items = [...selector.querySelectorAll('[data-city-item]')];
  const empty = selector.querySelector('[data-city-empty]');
  const suggestions = selector.querySelector('[data-city-suggestions]');
  const cityValue = selector.querySelector('[data-city-value]');
  const cityRegion = selector.querySelector('[data-city-region]');
  const form = selector.querySelector('[data-city-form]');
  const suggestion = document.querySelector('[data-city-suggestion]');

  const close = () => {
    selector.classList.remove('_opened');
    selector.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('city-selector-opened');
    window.sessionStorage.setItem('city-selector-dismissed', '1');
  };

  const open = () => {
    selector.classList.add('_opened');
    selector.setAttribute('aria-hidden', 'false');
    document.body.classList.add('city-selector-opened');
    if (suggestion) suggestion.hidden = true;
    window.setTimeout(() => search.focus(), 0);
  };

  document.querySelectorAll('[data-city-open]').forEach((button) => button.addEventListener('click', open));
  selector.querySelectorAll('[data-city-close]').forEach((button) => button.addEventListener('click', close));
  document.querySelector('[data-city-suggestion-close]')?.addEventListener('click', () => {
    suggestion.hidden = true;
  });

  const filterPopularCities = () => {
    const query = search.value.trim().toLocaleLowerCase('ru-RU');
    let visible = 0;
    items.forEach((item) => {
      const matches = item.textContent.trim().toLocaleLowerCase('ru-RU').includes(query);
      item.hidden = !matches;
      if (matches) visible += 1;
    });
    empty.hidden = visible > 0;
  };

  const showSuggestions = (locations) => {
    suggestions.replaceChildren();
    locations.forEach(({ city, region }) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = region && region !== city ? `${city}, ${region}` : city;
      button.addEventListener('click', () => {
        cityValue.value = city;
        cityRegion.value = region;
        search.value = city;
        form.requestSubmit();
      });
      suggestions.append(button);
    });
    suggestions.hidden = locations.length === 0;
  };

  let searchTimeout;
  items.forEach((item) => item.addEventListener('click', () => {
    cityValue.value = item.value;
    cityRegion.value = '';
  }));

  if (selector.hasAttribute('data-city-autostart') && !window.sessionStorage.getItem('city-selector-dismissed')) {
    open();
  }

  search.addEventListener('input', () => {
    cityValue.value = '';
    cityRegion.value = '';
    filterPopularCities();
    window.clearTimeout(searchTimeout);

    const query = search.value.trim();
    if (query.length < 2) {
      showSuggestions([]);
      return;
    }

    searchTimeout = window.setTimeout(async () => {
      try {
        const response = await fetch(DADATA_URL, {
          method: 'POST',
          headers: {
            Authorization: `Token ${DADATA_PUBLIC_TOKEN}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            query,
            from_bound: { value: 'city' },
            to_bound: { value: 'city' },
            count: 10,
          }),
        });
        const payload = await response.json();
        if (query !== search.value.trim()) {
          return;
        }
        const locations = payload.suggestions
          .map(({ data }) => ({
            city: data?.city,
            region: data?.region_with_type || data?.region || '',
          }))
          .filter(({ city }) => Boolean(city))
          .filter(({ city, region }, index, list) => list.findIndex((item) => item.city === city && item.region === region) === index);
        showSuggestions(locations);
      } catch (_) {
        showSuggestions([]);
      }
    }, 250);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
});
